<div class="patient">
  <div class="wrapper">
    <!-- =============== Header (Start) =============== -->
    <header class="l-header">
      <div class="on-mobile header-logo">
        <img src="assets/icons/logo.svg" alt="Artisan Sonics" />
      </div>
      <div class="l-header-panel">
        <div style="display: flex; align-items: center">
          <h1 class="t-title-main ws-nowrap">
            {{ "GUI.gastro.lab_results.title.lab_results" | translate }}
          </h1>
          <div
            class="l-flex l-flex-c t-field t-field-pad"
            style="margin-left: 2em"
          >
            @if (loginService.userType == "doctor") {
              <label style="font-size: 14pt">
                {{ "GUI.gastro.lab_results.title.status" | translate }}
              </label>

              <i class="t-sep"></i>
            }

            <select
              class="t-field t-select"
              [(ngModel)]="status"
              (change)="getLabResults()"
              style="font-size: 14pt"
            >
              @if ( false &&
                loginService.userType == "secretary" ||
                loginService.userType == "admin"
              ) {
                <option value="Old_reports">
                  {{ "GUI.gastro.lab_results.old_lab_inventories" | translate }}
                </option>
              }
              @if (
                loginService.userType == "nurse" ||
                loginService.userType == "secretary" ||
                loginService.userType == "admin"
              ) {
                <option value="Messenger_reports">
                  {{
                    "GUI.gastro.lab_results.lab_inventory_reports" | translate
                  }}
                  {{
                    loginService.userType == "secretary"
                      ? ("GUI.gastro.lab_results.labels.unsigned" | translate)
                      : ""
                  }}
                </option>
              }
              <option value="Needs_payer">
                {{ "GUI.gastro.lab_results.payer_missing" | translate }}
              </option>
              @if (
                loginService.userType == "nurse" ||
                loginService.userType == "secretary" ||
                loginService.userType == "admin"
              ) {
                <option
                  value="Awaiting_transfer"
                  matTooltip="{{
                    'GUI.gastro.lab_results.tooltips.new_samples' | translate
                  }}"
                >
                  {{ "GUI.gastro.lab_results.awaiting_pickup" | translate }}
                </option>
              }
              @if (loginService.userType != "nurse") {
                <option
                  value="Awaiting_Lab_Results"
                  matTooltip="{{
                    'GUI.gastro.lab_results.tooltips.sent_to_lab' | translate
                  }}"
                >
                  {{ "GUI.gastro.lab_results.awaiting_results" | translate }}
                </option>
                <option value="Needs_Analysis">
                  {{
                    "GUI.gastro.lab_results.awaiting_doctors_review" | translate
                  }}
                </option>
                <option value="Needs_Assignment">
                  {{ "GUI.gastro.lab_results.awaiting_assignment" | translate }}
                </option>
              }
              <!-- <option value="Biopsy_Stats" *ngIf="loginService.userType == 'secretary' || loginService.userType == 'admin'">Biopsy & Polypectomy Statistics</option> -->
            </select>
          </div>

          @if (
            status === "Needs_Analysis" &&
            loginService.userType == "doctor" &&
            labResults &&
            labResults.length > 0 &&
            reportSelected()
          ) {
            <div style="margin-left: 2em">
              <button
                class="orange-btn"
                style="width: max-content"
                (click)="markAsReviewed()"
                matTooltip="{{
                  'GUI.gastro.lab_results.tooltips.careful' | translate
                }}"
              >
                {{
                  "GUI.gastro.lab_results.buttons.mark_selected_as_reviewed"
                    | translate
                }}
              </button>
            </div>
          }

          @if (
            status == "Awaiting_transfer" || status == "Awaiting_Lab_Results"
          ) {
            <div
              class="l-flex l-flex-c t-field t-field-pad"
              style="margin-left: 2em"
            >
              <label>
                {{ "GUI.gastro.lab_results.labels.laboratory" | translate }}
              </label>

              <i class="t-sep"></i>

              <select
                class="t-field t-select"
                [(ngModel)]="lab"
                (change)="getLabResults()"
              >
                <option value="" disabled>
                  {{ "GUI.gastro.lab_results.selects.select_lab" | translate }}
                </option>
                @if (status == "Awaiting_Lab_Results") {
                  <option value="">
                    {{ "GUI.gastro.lab_results.selects.all" | translate }}
                  </option>
                }
                <option value="patholab">
                  {{ "GUI.gastro.lab_results.selects.patho_lab" | translate }}
                </option>
                <option value="medica">
                  {{ "GUI.gastro.lab_results.selects.medica" | translate }}
                </option>
                <option value="LEM">
                  {{ "GUI.gastro.lab_results.selects.lem" | translate }}
                </option>
                <option value="megalab">
                  {{ "GUI.gastro.lab_results.selects.mega_lab" | translate }}
                </option>
              </select>
            </div>
          }

          <nav class="header-menu">
            @if (
              loginService.userType === "nurse" &&
              status == "Awaiting_transfer" &&
              lab &&
              labResults &&
              labResults.length > 0 &&
              reportSelected()
            ) {
              <span
                class="header-menu-link icon-file"
                matTooltip="Sign sample list for messenger"
                (click)="makeMessengerReport()"
              >
              </span>
            }
          </nav>
        </div>

        @if (status == "Old_reports") {
          <span
            style="
              margin-left: 1em;
              display: flex;
              align-items: center;
              gap: 1em;
            "
          >
            {{ "GUI.gastro.lab_results.labels.from" | translate }}
            <input
              [matDatepicker]="startDatepicker"
              [(ngModel)]="startdate"
              [max]="enddate"
              class="t-field t-field--date menstural-field"
              aria-labelledby="menstural_LMP"
              (click)="startDatepicker.open()"
              (dateChange)="getInventoryHistory()"
            />
            <mat-datepicker #startDatepicker></mat-datepicker>
            {{ "GUI.gastro.lab_results.labels.until" | translate }}
            <input
              [matDatepicker]="endDatepicker"
              [(ngModel)]="enddate"
              [min]="startdate"
              (click)="endDatepicker.open()"
              class="t-field t-field--date menstural-field"
              aria-labelledby="menstural_LMP"
              (dateChange)="getInventoryHistory()"
            />
            <mat-datepicker #endDatepicker></mat-datepicker>
          </span>
        }
        <div
          style="
            width: 70%;
            display: flex;
            flex-direction: row;
            justify-content: space-around;
            align-items: center;
          "
        >
          <nav class="on-mobile header-mobilePanel">
            <button
              class="btn-mobileMenu"
              id="open-mainNav"
              data-show=".l-sidebar"
              aria-label="open mobile sidebar"
            ></button>
          </nav>
          @if (
            (loginService.isAdmin ||
              loginService.userType == "secretary" ||
              loginService.userType == "nurse") &&
            (loginService.separatedClinic || loginService.SeparateZimun)
          ) {
            <div style="position: absolute; right: 6em">
              @if (
                loginService.userType != "doctor" &&
                status != "Messenger_reports"
              ) {
                <div class="l-flex l-flex-c t-field t-field-pad">
                  <label
                    matTooltip="{{
                      'GUI.gastro.lab_results.tooltips.doctors_name' | translate
                    }}"
                  >
                    <img src="../../assets/icons/drb.svg" />
                  </label>

                  <i class="t-sep"></i>

                  <span class="t-validation-wrap l-fg1">
                    <select
                      [(ngModel)]="doctor"
                      class="t-select w100"
                      style="text-align: center"
                      (change)="getLabResults()"
                    >
                      <option [value]="null">
                        {{ "GUI.gastro.lab_results.selects.all" | translate }}
                      </option>
                      <!-- <option *ngIf="awlExam && ! examTypes.includes(awlExam)" [value]="awlExam">{{awlExam}}</option> -->
                      <!-- =============== Doctor Options Loop (Start) =============== -->
                      @for (e of loginService.clinicUsers; track e.UID) {
                        <option [value]="e.UID">{{ e.Name }}</option>
                      }
                      <!-- =============== Doctor Options Loop (End) =============== -->
                    </select>
                  </span>
                </div>
              }
            </div>
          }

          <!-- *ngIf="examList && examList.length && this.loginService.userType==='admin'" -->
          @if (false && this.loginService.userType === "admin") {
            <img
              style="
                cursor: pointer;
                position: absolute;
                right: 3%;
                top: 50%;
                transform: translateY(-50%);
              "
              matTooltip="Download CSV"
              height="31em"
              src="../../assets/icons/file.svg"
            />
          }
        </div>
      </div>
    </header>
    <!-- =============== Header (End) =============== -->

    <!-- =============== Lab Results (Payer Missing / Awaiting Pickup / Awaiting Results / Doctor's Review / Assignment) (Start) =============== -->
    @if (
      status != "Messenger_reports" &&
      status != "Old_reports" &&
      status != "Biopsy_Stats"
    ) {
      <main class="l-deashboard">
        @if (resLoading) {
          <div class="list-spinner-wrap">
            <img
              src="../../assets/images/Wedges.svg"
              alt="Loading..."
              class="list-spinner-img"
            />
          </div>
        } @else {
          @if (!labResults || labResults.length === 0) {
            @if (status == "Awaiting_transfer" && !lab) {
              <p class="empty-state">
                {{
                  "GUI.gastro.lab_results.labels.select a laboratory to view samples"
                    | translate
                }}
              </p>
            } @else {
              <p class="empty-state">
                {{
                  "GUI.gastro.lab_results.labels.no lab results available"
                    | translate
                }}
              </p>
            }
          }
          @if (isPaginatedStatus() && labResults && labResults.length > 0) {
            <app-pagination-controls
              [total]="resTotal"
              [page]="resPage"
              [totalPages]="resTotalPages"
              (prev)="resPrevPage()"
              (next)="resNextPage()"
            ></app-pagination-controls>
          }
          <!-- =============== Lab Result Rows Loop (Start) =============== -->
          @for (result of labResults; track result.ID) {
            <div class="l-flex patient-item">
              <button
                [matTooltip]="getPathNotes(result)"
                class="w100 patient-item-link"
              >
                <div class="l-table h100" (click)="showReport(result)">
                  @if (
                    loginService.userType === "nurse" &&
                    status == "Awaiting_transfer" &&
                    lab
                  ) {
                    <span class="l-td-m patient-item-cell patient-id">
                      Add to report
                      <input
                        type="checkbox"
                        [(ngModel)]="result.selected"
                        (ngModelChange)="toggleSelected(result)"
                      />
                    </span>
                  }
                  @if (
                    status === "Needs_Analysis" &&
                    loginService.userType == "doctor" &&
                    labResults &&
                    labResults.length > 0
                  ) {
                    <span
                      class="l-td-m patient-item-cell patient-id"
                      style="width: 2.5em"
                    >
                      <input
                        type="checkbox"
                        style="width: 18px; height: 18px; cursor: pointer"
                        [(ngModel)]="result.selected"
                        (ngModelChange)="toggleSelected(result)"
                        (click)="$event.stopPropagation()"
                      />
                    </span>
                  }
                  <span class="l-td-m patient-item-cell patient-id">
                    <strong>ID: {{ result.ID }}</strong>
                  </span>

                  @if (result.Last) {
                    <span class="l-td-m patient-item-cell patient-name-first">
                      {{ result.First + " " + result.Last }}
                    </span>
                  }
                  @if (!result.First && !result.Last && !result.PID) {
                    <span class="l-td-m patient-item-cell patient-name-first">
                      Patient NOT found!
                    </span>
                  }
                  @if (result.ExamType && result.CreationTime) {
                    <span class="l-td-m patient-item-cell patient-name-first">
                      {{ result.ExamType }}
                      {{ result.CreationTime | date: "dd/MM/yyyy" }}
                    </span>
                  }
                  @if (result.Count) {
                    <span class="l-td-m patient-item-cell patient-name-first">
                      Num. of samples: {{ result.pathology.length }} of
                      {{ result.Count }}
                    </span>
                  }
                  @if (result.ReceptionDate) {
                    <span class="l-td-m patient-item-cell patient-name-first">
                      Recv. {{ result.Lab }} on
                      {{ result.ReceptionDate | date: "dd/MM/yyyy" }}
                    </span>
                  }
                  @if (result.ReceptionDate) {
                    <span
                      class="l-td-m patient-item-cell patient-name-first"
                      [ngClass]="result.exception ? 'problem' : ''"
                    >
                      Results: {{ result.exception ? "Abnormal" : "Normal" }}
                    </span>
                  }
                  @if (
                    (loginService.isAdmin ||
                      loginService.userType == "secretary") &&
                    result.UID
                  ) {
                    <span class="l-td-m patient-item-cell patient-name-first">
                      Dr: {{ loginService.getDocByUID(result.UID) }}
                    </span>
                  }
                </div>
              </button>
              @if (result.ExamID) {
                <a
                  class="l-td-m patient-item-exit"
                  matTooltip="Open Exam"
                  (click)="goExam(result.ExamID, result.PID)"
                ></a>
              }
              @if (status == "Needs_Assignment" && result.PID) {
                <a
                  class="l-td-m patient-item-exit"
                  matTooltip="Open Patient"
                  (click)="goPatient(result.PID)"
                ></a>
              }
            </div>
          }
          <!-- =============== Lab Result Rows Loop (End) =============== -->
          @if (
            isPaginatedStatus() &&
            labResults &&
            labResults.length > 0 &&
            resTotalPages > 1
          ) {
            <app-pagination-controls
              [total]="resTotal"
              [page]="resPage"
              [totalPages]="resTotalPages"
              (prev)="resPrevPage()"
              (next)="resNextPage()"
            ></app-pagination-controls>
          }
        }
      </main>
    }
    <!-- =============== Lab Results (Payer Missing / Awaiting Pickup / Awaiting Results / Doctor's Review / Assignment) (End) =============== -->

    <!-- =============== Lab Inventory Reports / Old Lab Inventories (Start) =============== -->
    @if (status == "Messenger_reports" || status == "Old_reports") {
      <main class="reports">
        @if (status == "Messenger_reports" ? invLoading : compLoading) {
          <div class="list-spinner-wrap">
            <img
              src="../../assets/images/Wedges.svg"
              alt="Loading..."
              class="list-spinner-img"
            />
          </div>
        } @else {
          @if (
            status == "Messenger_reports" &&
            (!activeInventories || activeInventories.length === 0)
          ) {
            <p class="empty-state">
              {{
                "GUI.gastro.lab_results.labels.no_inventory_reports_available"
                  | translate
              }}
            </p>
          }
          @if (
            status == "Old_reports" &&
            (!completedInventories || completedInventories.length === 0)
          ) {
            <p class="empty-state">
              {{
                "GUI.gastro.lab_results.labels.no_old_inventories_available"
                  | translate
              }}
            </p>
          }
          @if (
            status == "Messenger_reports" &&
            activeInventories &&
            activeInventories.length > 0
          ) {
            <app-pagination-controls
              [total]="invTotal"
              [page]="invPage"
              [totalPages]="invTotalPages"
              (prev)="invPrevPage()"
              (next)="invNextPage()"
            ></app-pagination-controls>
          }
          @if (
            status == "Old_reports" &&
            completedInventories &&
            completedInventories.length > 0
          ) {
            <app-pagination-controls
              [total]="compTotal"
              [page]="compPage"
              [totalPages]="compTotalPages"
              (prev)="compPrevPage()"
              (next)="compNextPage()"
            ></app-pagination-controls>
          }
          <!-- =============== Inventory Rows Loop (Start) =============== -->
          @for (
            inventory of status == "Messenger_reports"
              ? activeInventories
              : completedInventories;
            track inventory.AutoIndex
          ) {
            <div class="l-flex patient-item">
              <button class="w100 patient-item-link">
                <div
                  class="l-table h100"
                  (click)="
                    inventory.LabMessenger
                      ? openOldInventory(inventory)
                      : openInventory(inventory)
                  "
                >
                  <span class="l-td-m patient-item-cell patient-id">
                    <strong>
                      {{
                        "GUI.gastro.lab_results.labels.inventory id"
                          | translate
                      }}:
                    </strong>
                    {{ inventory.AutoIndex }}
                  </span>

                  <span class="l-td-m patient-item-cell patient-name-first">
                    <strong>
                      {{ "GUI.gastro.lab_results.labels.lab" | translate }}:
                    </strong>
                    {{ inventory.Lab }}
                  </span>
                  <span class="l-td-m patient-item-cell patient-name-first">
                    <strong>
                      {{
                        "GUI.gastro.lab_results.labels.pickup date" | translate
                      }}:
                    </strong>
                    {{ inventory.PickupDate | date: "dd/MM/yyyy" }}
                  </span>
                  @if (
                    !inventory.SigningNurse ||
                    !inventory.SigningSecretary ||
                    !inventory.LabMessenger
                  ) {
                    <span class="l-td-m patient-item-cell patient-name-first">
                      {{ getNeededSignatures(inventory) }}
                    </span>
                  }
                  @if (inventory.LabMessenger) {
                    <span class="l-td-m patient-item-cell patient-name-first">
                      {{
                        "GUI.gastro.lab_results.labels.completed by messenger"
                          | translate
                      }}: {{ inventory.LabMessenger }} on
                      {{ inventory.MessengerDate | date: "dd/MM/yyyy" }}
                    </span>
                  }
                </div>
              </button>
            </div>
          }
          <!-- =============== Inventory Rows Loop (End) =============== -->
          @if (
            status == "Messenger_reports" &&
            activeInventories &&
            activeInventories.length > 0 &&
            invTotalPages > 1
          ) {
            <app-pagination-controls
              [total]="invTotal"
              [page]="invPage"
              [totalPages]="invTotalPages"
              (prev)="invPrevPage()"
              (next)="invNextPage()"
            ></app-pagination-controls>
          }
          @if (
            status == "Old_reports" &&
            completedInventories &&
            completedInventories.length > 0 &&
            compTotalPages > 1
          ) {
            <app-pagination-controls
              [total]="compTotal"
              [page]="compPage"
              [totalPages]="compTotalPages"
              (prev)="compPrevPage()"
              (next)="compNextPage()"
            ></app-pagination-controls>
          }
        }
      </main>
    }
    <!-- =============== Lab Inventory Reports / Old Lab Inventories (End) =============== -->

    <!-- =============== Biopsy & Polypectomy Statistics (Start) =============== -->
    <!-- <div *ngIf="status == 'Biopsy_Stats'" style="width: 100%; padding: 0; margin-top: 0;">
       <app-biopsystats [embedded]="true"></app-biopsystats>
     </div> -->
    <!-- =============== Biopsy & Polypectomy Statistics (End) =============== -->

    <!-- =============== Sidebar (Start) =============== -->
    <aside class="l-sidebar l-flex l-column">
      <img
        class="off-mobile sidebar-logo"
        src="assets/icons/logo.svg"
        alt="Artisan Sonics"
      />

      <!-- user panel (start) -->
      <div class="userPanel">
        <div class="search-patient">
          <div class="w100">
            <button
              class="blue-btn"
              matTooltip="{{
                'GUI.gastro.lab_results.tooltips.patients' | translate
              }}"
              routerLink="/patsearch"
            >
              {{
                "GUI.gastro.lab_results.buttons.go_back_to_patients" | translate
              }}
            </button>
          </div>
        </div>
      </div>
      <!-- user panel (end) -->

      <!-- main nav (start) -->
      <nav class="mainNav l-fg1 scroller"></nav>
      <!-- main nav (end) -->
      <app-docpanel></app-docpanel>
    </aside>

    <!-- =============== Sidebar (End) =============== -->

    <app-bottombar></app-bottombar>
  </div>
</div>

@if (messengerReportID) {
  <app-messenger-report
    [lab]="lab"
    [reportID]="messengerReportID"
    (closed)="closeWPDF($event)"
    [signed]="inventorySigned"
  ></app-messenger-report>
}
@if (reportView()) {
  <app-labreport
    [reportid]="reportToShow"
    (closed)="closeWPDF(null)"
    [pdf]="pdf"
    [inventoryId]="pdfMessengerID"
  ></app-labreport>
}
